

















import {
    Component,
    Prop,
    Vue,
} from 'vue-property-decorator';
import responsive from './responsive';

@Component({})
export default class Description extends Vue {
    @Prop({
        type: String,
        default: '',
    })
    private term!: string;

    @Prop({
        type: Number,
        default: 3,
    })
    private column!: number;

    private responsive: any = responsive;

    get colResponsive() {
        return this.responsive[this.column];
    }

    /****
     * {...restProps}
     */
}
